import { Redirect, useLocation } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-IsMobile';

const ROUTES = {
  DASHBOARD: '/dashboard',
  MOBILE_FALLBACK: '/tasks/jobs/approvals',
};

const QUERY_PARAMS = {
  SECTION: 'section',
  TAB: 'tab',
  OFFER_ID: 'offerId',
  REQUISITION_ID: 'requisitionId',
  REQUISITION_GROUP_ID: 'requisitionGroupId',
  JOB_ID: 'jobId',
  ACTION: 'action',
};

const VALID_VALUES = {
  SECTION: 'openTasks',
  TABS: {
    OFFER_APPROVAL: 'offerApproval',
    REQUISITION_APPROVAL: 'requisitionApproval',
  },
  JOB_ACTIONS: ['approved', 'rejected'],
};

// Allow only valid mobile dashboard routes
const isValidDashboardMobileRoute = (search) => {
  if (!search) return false;

  const params = new URLSearchParams(search);

  // Job approval view: /dashboard?jobId={id}&action=approved|rejected
  if (
    params.get(QUERY_PARAMS.JOB_ID) &&
    VALID_VALUES.JOB_ACTIONS.includes(params.get(QUERY_PARAMS.ACTION))
  ) {
    return true;
  }

  const section = params.get(QUERY_PARAMS.SECTION);
  const tab = params.get(QUERY_PARAMS.TAB);

  if (section !== VALID_VALUES.SECTION || !tab) return false;

  return (
    (tab === VALID_VALUES.TABS.OFFER_APPROVAL &&
      params.get(QUERY_PARAMS.OFFER_ID)) ||
    (tab === VALID_VALUES.TABS.REQUISITION_APPROVAL &&
      (params.get(QUERY_PARAMS.REQUISITION_ID) ||
        params.get(QUERY_PARAMS.REQUISITION_GROUP_ID)))
  );
};

export const MobileRouteGuard = ({ children }) => {
  const isMobile = useIsMobile();
  const { pathname, search } = useLocation();

  // Handle redirect synchronously to prevent Suspense race conditions
  // If we're on mobile and on the dashboard route with an invalid route,
  // return Redirect immediately instead of rendering children
  const shouldRedirect =
    isMobile &&
    pathname === ROUTES.DASHBOARD &&
    !isValidDashboardMobileRoute(search);

  if (shouldRedirect) {
    return <Redirect to={ROUTES.MOBILE_FALLBACK} />;
  }

  return children;
};
